import React from 'react'
import { MediaLibraryProvider } from './MediaLibraryContext'
import MediaLibraryContent from './MediaLibraryContent'
import { DEFAULT_ACCEPT } from './utils/constants'
import { BaseMediaLibraryProps, MediaFileProps } from './types'

export type MediaLibraryContentProps = {
	search?: {
		searchText?: string
		handleSearchChange?: (
			e: React.ChangeEvent<HTMLInputElement>
		) => void
		handleClearSearchClick?: () => void
	}
	pagination?: {
		pageNumber: number
		pageSize: number
		sortBy: string
		sortDirection: 'asc' | 'desc'
		handleSort: (
			column: keyof MediaFileProps,
			direction: 'asc' | 'desc'
		) => void
		handleRowsPerPageChange: (
			newPageSize: number,
			pageNumber: number
		) => void
		handlePageChange: (pageNumber: number) => void
	}
}
export type MediaLibraryProps = BaseMediaLibraryProps &
	MediaLibraryContentProps

const MediaLibrary = ({
	data,
	folders,
	title,
	selectActions,
	bulkSelectActions,
	search,
	pagination,
	onRefreshClick,
	onUpload,
	loading = false,
	accept = DEFAULT_ACCEPT,
}: MediaLibraryProps) => {
	return (
		<MediaLibraryProvider
			data={data}
			folders={folders}
			title={title}
			loading={loading}
			selectActions={selectActions}
			bulkSelectActions={bulkSelectActions}
			onRefreshClick={onRefreshClick}
			onUpload={onUpload}
			accept={accept}
		>
			<MediaLibraryContent search={search} pagination={pagination} />
		</MediaLibraryProvider>
	)
}

export default MediaLibrary
